import {useQuery} from "react-query";
import {platformAPI} from "@/api/axiosConfig";

export type DriverBillingStat = {
    clientID: string
    driverID: string
    driverType: string
    fromAddress: string
    region: string
    smsSent: number
    smsSegments: number
    emailSent: number
    callsSent: number
    callSeconds: number
}

export function useGetSirenBillingStats(from: string, to: string, clientID?: string | null) {
    return useQuery(
        ["siren-billing-stats", from, to, clientID ?? ""],
        () => platformAPI.get<DriverBillingStat[]>("api/siren/billing-stats", {
            params: {from, to, ...(clientID ? {clientID} : {})},
        }).then(r => r.data),
        {enabled: !!from && !!to},
    )
}
